import { Application } from '../Application'
import { TabItem } from './TabItem'

export class TabComponent {

    public Id: string;
    public Current: TabItem = null;
    public Items: TabItem[] = [];

    constructor(private Application: Application, private $Root: JQuery) {

        this.Id = $Root.attr("id");
        $Root.find("[role=tab]").each((i: number, e: HTMLElement) => {
            let tabItem = new TabItem();
            tabItem.$Header = $(e);
            tabItem.$Panel = $("#" + tabItem.$Header.attr("aria-controls"));
            tabItem.IsSelected = tabItem.$Header.attr("aria-selected") === "true";
            if (tabItem.IsSelected) {
                this.Current = tabItem;
                tabItem.IsLoaded = true;
            }
            tabItem.$Header.data("TabItem", tabItem);
            this.Items.push(tabItem);
        });

        this.$Root.on("click", "[role=tab]", (ev) => this.OnClick(ev));
    }

    private OnClick(ev: JQuery.ClickEvent) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        var tabItem = $(ev.currentTarget).data("TabItem");
        if (tabItem) {
            this.UpdateTabVisibility(tabItem);
            this.$Root.trigger("tab.show", [tabItem]);
            tabItem.IsLoaded = true;
        }
    }

    private UpdateTabVisibility(tabItem: TabItem) {

        var isSelected: boolean = false;
        var tabSelectedButContentHidden = tabItem.$Header.attr("aria-selected") === "true" &&
            tabItem.$Panel.attr("aria-hidden") === "true"; // when tab is loaded on page load by default but hidden
        if (tabItem.$Header.attr("aria-selected") === "false" || tabSelectedButContentHidden) {
            //show selected tab and hide others
            tabItem.$Header.attr("aria-selected", "true").siblings().attr("aria-selected", "false");

            //show related tab panel and hide others
            if (tabItem.$Panel.attr("role") === "tabpanel") {
                tabItem.$Panel.attr("aria-hidden", "false").siblings().attr("aria-hidden", "true");
                //set focus on first input element
                tabItem.$Panel.find("input[type=text],input[type=email]").first().focus();
            }

            this.Current = tabItem;
            tabItem.IsSelected = true;
            isSelected = true;

        }
    }
}
